import React from 'react';

interface ListWithDescriptionProps {
  items: { title: string; content: string[] }[];
  layout?: 'split' | 'stacked';
  titleListType?: 'decimal' | 'disc' | 'none';
}

const ListWithDescription: React.FC<ListWithDescriptionProps> = ({
  items,
  layout = 'split',
  titleListType = 'disc',
}) => {
  const isSplit = layout === 'split';

  return (
    <div className={`grid ${isSplit ? 'grid-cols-11' : 'grid-cols-1'} text-justify`}>
      {items.map((item, index) => (
        <div
          key={index}
          className={
            isSplit
              ? `col-span-11 lg:col-start-${index % 2 === 0 ? 1 : 7} lg:col-span-5`
              : 'col-span-1'
          }
        >
          <div className="pl-4 py-2">
            {/* Title Row */}
            <div className="flex items-baseline gap-2 h1 leading-relaxed word-spacing-wide break-normal overflow-wrap-anywhere lg:py-2">
              <span className="min-w-[1.5em]">
                {titleListType === 'decimal' && `${index + 1}.`}
                {titleListType === 'disc' && '•'}
              </span>
              <span>{item.title}</span>
            </div>

            {/* Content Paragraphs */}
            {item.content.map((subItem, subIndex) => (
              <div
                key={subIndex}
                className="pl-[2.3em] py-2 content-text-size break-normal tracking-tight leading-relaxed text-justify">
                {subItem}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListWithDescription;
